import { useObjectVal } from "react-firebase-hooks/database";
import { ref, child } from "firebase/database";
import { database } from "hooks/useFirebase";

export const useFirebaseRef = (id) => {
  if (!id) return null;
  return child(ref(database, "okoServer"), id);
};

export const useGesture = (participant) => {
  const reference = useFirebaseRef(participant ? participant.sid : null);
  const [gesture, loading, error] = useObjectVal(reference);

  return { gesture, loading, error };
};
